import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import CasesPage from "../pages/cases/page";
import CaseDetailPage from "../pages/cases/detail/page";
import FactCheckPage from "../pages/fact-check/page";
import GuidePage from "../pages/guide/page";
import GuideDetailPage from "../pages/guide/detail/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "cases", element: <CasesPage /> },
      { path: "cases/:slug", element: <CaseDetailPage /> },
      { path: "fact-check", element: <FactCheckPage /> },
      { path: "guide", element: <GuidePage /> },
      { path: "guide/:slug", element: <GuideDetailPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;